import React from 'react';

import { Container } from './styles';

export default function BgBlack({zIndex, onClick}) {
  return (
    <Container zIndex={zIndex} onClick={onClick} />
  );
}
